import { render, staticRenderFns } from "./AccessGuide.vue?vue&type=template&id=cdc8107c&scoped=true"
import script from "./AccessGuide.vue?vue&type=script&lang=js"
export * from "./AccessGuide.vue?vue&type=script&lang=js"
import style0 from "./AccessGuide.vue?vue&type=style&index=0&id=cdc8107c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc8107c",
  null
  
)

export default component.exports